import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronExpandMdVericalLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 4.25C11.8081 4.25 11.6152 4.3223 11.4688 4.46875L7.46875 8.46875C7.17586 8.76164 7.17586 9.23836 7.46875 9.53125C7.76164 9.82414 8.23836 9.82414 8.53125 9.53125L12 6.06055L15.4688 9.53125C15.7617 9.82414 16.2384 9.82414 16.5313 9.53125C16.8242 9.23836 16.8242 8.76164 16.5313 8.46875L12.5313 4.46875C12.3848 4.32231 12.1919 4.25 12 4.25ZM8 14.25C7.80806 14.25 7.6152 14.3223 7.46875 14.4688C7.17586 14.7616 7.17586 15.2384 7.46875 15.5312L11.4688 19.5312C11.7617 19.8241 12.2384 19.8241 12.5313 19.5312L16.5313 15.5312C16.8242 15.2384 16.8242 14.7616 16.5313 14.4688C16.2384 14.1759 15.7617 14.1759 15.4688 14.4688L12 17.9395L8.53125 14.4688C8.38481 14.3223 8.19194 14.25 8 14.25Z",
		fill: "currentColor"
	})
});
export default SvgChevronExpandMdVericalLine;
